import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    role = '',
    title = '',
    desc = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.role.save, {
        role,
        title,
        desc,
    }, options);
    if (error) return { error, status };
    return content || {};
};

